export const rqStatusEnum = {
  default: 'DEFAULT',
  inProgress: 'IN_PROGRESS',
  error: 'ERROR',
  success: 'SUCCESS',
}
